import { useState } from "react";
//--------------------------------------------------------------------------------------------
import JSAItem from "src/components/workLogs/formTemplates/jsa";
//--------------------------------------------------------------------------------------------
export default function MultiSiteJSA({
    setWorkLogs, 
    setWorkInstructions,
    closeIt, 
    form, // sub only
    /*---- workInstruction ----------------------------------------*/
    workInstructionHashKey, 
    location, 
    /*---- workLog ------------------------------------------------*/
    workLogHashKey,
    projectName, 
    // laborCategory,
    // laborName
    nearestMedicalFacility, 
    /*---- admin --------------------------------------------------*/
    adminLink,
    /*-------------------------------------------------------------*/
}){
    const [mainLaborCategory, setMainLaborCategory] = useState("");
    const [mainLaborName, setMainLaborName] = useState("");
    const [helpers, setHelpers] = useState(form.helpers);
    const jobSafetyAnalysisContent = form.content || {};
    return (
        <JSAItem
            formTitle = {form.form.toUpperCase()}
            jobSafetyAnalysisContent = {jobSafetyAnalysisContent}
            setWorkLogs = {setWorkLogs}
            setWorkInstructions = {setWorkInstructions}
            closeIt = {closeIt}
            /*---- workInstruction ---------------------------------------*/
            workInstructionHashKey = {workInstructionHashKey}
            location = {location}
            /*---- workLog -----------------------------------------------*/
            workLogHashKey = {workLogHashKey}
            projectName = {projectName}
            nearestMedicalFacility = {nearestMedicalFacility}
            /*---- admin -------------------------------------------------*/
            adminLink = {adminLink}
            /*------------------------------------------------------------*/
            /*---- unique ------------------------------------------------*/
            mainLaborCategory = {mainLaborCategory}
            setMainLaborCategory = {setMainLaborCategory}
            mainLaborName = {mainLaborName}
            setMainLaborName = {setMainLaborName}
            helpers = {helpers}
            setHelpers = {setHelpers}
            formWorkLogHashKey = {form.workLogHashKey}
            formHashKey = {form.hashKey}
        />
    )
}